/**Based on the folder section the content in that folder will be displayed through this component**/

import React, { useState, useRef, useEffect } from "react";
import { FileText, Search } from "lucide-react";
import { toast } from "react-toastify";
import { getData, postDataWithBody } from '../../../../Services/Services';
import { getallBanks, getbarches, getThemeURL, getallBanksByRole } from '../../../../Services/EndPoints';
import { Download, Play, FileMusic, FileIcon } from 'lucide-react';

const FoldersContent = ({ folderId }) => {
    const [documents, setDocuments] = useState([
        // Files inside Tasks Documents folder
        {
            id: 101,
            name: "task-list",
            type: "pdf",
            uploadedBy: "Vivek Singh",
            size: "2.2 MB",
            parentId: 1,
            bank: "HDFC Bank",
            branch: "Delhi Branch",
            date: "10-01-2025"
        },
        {
            id: 102,
            name: "project-schedule",
            type: "excel",
            uploadedBy: "Vivek Singh",
            size: "1.8 MB",
            parentId: 1,
            bank: "ICICI Bank",
            branch: "Pune Branch",
            date: "11-01-2025"
        },
        {
            id: 103,
            name: "team-assignments",
            type: "word",
            uploadedBy: "Vivek Singh",
            size: "0.9 MB",
            parentId: 1,
            bank: "Axis Bank",
            branch: "Lucknow Branch",
            date: "12-01-2025"
        },
        // Files inside Website html folder
        {
            id: 201,
            name: "homepage",
            type: "text",
            uploadedBy: "Ajeth Singh",
            size: "0.4 MB",
            parentId: 2,
            bank: "SBI",
            branch: "Bangalore Branch",
            date: "15-01-2025"
        },
        {
            id: 202,
            name: "styles",
            type: "text",
            uploadedBy: "Ajeth Singh",
            size: "0.2 MB",
            parentId: 2,
            bank: "Yes Bank",
            branch: "Chennai Branch",
            date: "16-01-2025"
        },
        {
            id: 203,
            name: "main",
            type: "text",
            uploadedBy: "Ajeth Singh",
            size: "0.3 MB",
            parentId: 2,
            bank: "Bank of Baroda",
            branch: "Kolkata Branch",
            date: "17-01-2025"
        },
        // Files inside Loans folder
        {
            id: 301,
            name: "loan-policy",
            type: "pdf",
            uploadedBy: "Manvyata Singh",
            size: "3.4 MB",
            parentId: 3,
            bank: "Canara Bank",
            branch: "Hyderabad Branch",
            date: "18-01-2025"
        },
        {
            id: 302,
            name: "interest-rates",
            type: "excel",
            uploadedBy: "Manvyata Singh",
            size: "1.1 MB",
            parentId: 3,
            bank: "Punjab National Bank",
            branch: "Patna Branch",
            date: "19-01-2025"
        },
        // Files inside Loans Forms folder
        {
            id: 401,
            name: "personal-loan-form",
            type: "pdf",
            uploadedBy: "Vishal Singh",
            size: "0.8 MB",
            parentId: 4,
            bank: "Union Bank",
            branch: "Jaipur Branch",
            date: "20-01-2025"
        },
        {
            id: 402,
            name: "business-loan-form",
            type: "pdf",
            uploadedBy: "Vishal Singh",
            size: "1.2 MB",
            parentId: 4,
            bank: "IDFC First Bank",
            branch: "Surat Branch",
            date: "21-01-2025"
        },
        {
            id: 403,
            name: "mortgage-form",
            type: "pdf",
            uploadedBy: "Vishal Singh",
            size: "1.5 MB",
            parentId: 4,
            bank: "Kotak Mahindra Bank",
            branch: "Indore Branch",
            date: "22-01-2025"
        },
        // Files inside Content for ads folder
        {
            id: 501,
            name: "summer-campaign",
            type: "video",
            uploadedBy: "Vivek Kumar",
            size: "8.7 MB",
            parentId: 5,
            bank: "Federal Bank",
            branch: "Thiruvananthapuram Branch",
            date: "23-01-2025"
        },
        {
            id: 502,
            name: "banner-designs",
            type: "image",
            uploadedBy: "Vivek Kumar",
            size: "5.3 MB",
            parentId: 5,
            bank: "DBS Bank",
            branch: "Ahmedabad Branch",
            date: "24-01-2025"
        },
        {
            id: 503,
            name: "radio-ad",
            type: "audio",
            uploadedBy: "Vivek Kumar",
            size: "2.4 MB",
            parentId: 5,
            bank: "RBL Bank",
            branch: "Nagpur Branch",
            date: "25-01-2025"
        },
        // Files inside Branches details folder
        {
            id: 601,
            name: "branch-locations",
            type: "excel",
            uploadedBy: "Ajeth Singh",
            size: "2.8 MB",
            parentId: 6,
            bank: "UCO Bank",
            branch: "Bhopal Branch",
            date: "26-01-2025"
        },
        {
            id: 602,
            name: "staff-directory",
            type: "pdf",
            uploadedBy: "Ajeth Singh",
            size: "4.5 MB",
            parentId: 6,
            bank: "South Indian Bank",
            branch: "Kochi Branch",
            date: "27-01-2025"
        },
        {
            id: 603,
            name: "facility-photos",
            type: "archive",
            uploadedBy: "Ajeth Singh",
            size: "12.6 MB",
            parentId: 6,
            bank: "IndusInd Bank",
            branch: "Ranchi Branch",
            date: "28-01-2025"
        },
        // Root files (no parent folder)
        {
            id: 7,
            name: "approval",
            type: "pdf",
            uploadedBy: "Vivek Singh",
            size: "4.2 MB",
            bank: "Bank of Maharashtra",
            branch: "Delhi Branch",
            date: "29-01-2025"
        },
        {
            id: 8,
            name: "customer-data",
            type: "excel",
            uploadedBy: "Ajeth Singh",
            size: "3.4 MB",
            bank: "IDBI Bank",
            branch: "Mumbai Branch",
            date: "30-01-2025"
        },
        {
            id: 9,
            name: "staffd",
            type: "text",
            uploadedBy: "Ajeth Singh",
            size: "1.3 MB",
            bank: "Indian Overseas Bank",
            branch: "Chennai Branch",
            date: "31-01-2025"
        },
        {
            id: 10,
            name: "sales-presentation",
            type: "powerpoint",
            uploadedBy: "Manvyata Singh",
            size: "3.2 MB",
            bank: "Central Bank of India",
            branch: "Kolkata Branch",
            date: "01-02-2025"
        },
        {
            id: 11,
            name: "meeting-notes",
            type: "word",
            uploadedBy: "Ajeth Singh",
            size: "2.7 MB",
            bank: "Karur Vysya Bank",
            branch: "Madurai Branch",
            date: "02-02-2025"
        },
        {
            id: 12,
            name: "server-backup",
            type: "archive",
            uploadedBy: "Vishal Singh",
            size: "4.7 MB",
            bank: "Yes Bank",
            branch: "Mumbai Branch",
            date: "03-02-2025"
        },
        {
            id: 13,
            name: "meeting-audio-recording",
            type: "audio",
            uploadedBy: "Ajeth Singh",
            size: "4.2 MB",
            bank: "City Union Bank",
            branch: "Coimbatore Branch",
            date: "04-02-2025"
        },
        {
            id: 14,
            name: "tv-commercial",
            type: "video",
            uploadedBy: "Vivek Kumar",
            size: "4.9 MB",
            bank: "Dhanlaxmi Bank",
            branch: "Vijayawada Branch",
            date: "05-02-2025"
        },
        {
            id: 15,
            name: "final-logo",
            type: "image",
            uploadedBy: "Vishal Singh",
            size: "2.7 MB",
            bank: "Tamilnad Mercantile Bank",
            branch: "Erode Branch",
            date: "06-02-2025"
        },
    ]);
    const getStaticDocumentPath = (type) => {
        const sampleFiles = {
            pdf: '/static/docs/sample.pdf',
            excel: '/static/docs/sample.xlsx',
            word: '/static/docs/sample.docx',
            powerpoint: '/static/docs/sample.pptx',
            image: '/static/docs/sample.jpg',
            video: '/static/docs/sample.mp4',
            audio: '/static/docs/sample.mp3',
            text: '/static/docs/sample.txt'
        };
        return sampleFiles[type.toLowerCase()] || null;
    };
    const [searchQuery, setSearchQuery] = useState("");
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [typeCategories] = useState(["All", "Document", "Audio", "Video", "Image", "Folder"]);
    const [selectedType, setSelectedType] = useState("All");
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
    const [sizeError, setSizeError] = useState("");
    const [documentName, setDocumentName] = useState("");
    const [selectedRegion, setSelectedRegion] = useState("");
    const [selectedBank, setSelectedBank] = useState("");
    const [selectedBranch, setSelectedBranch] = useState("");
    const [currentFolder, setCurrentFolder] = useState(null);
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    const [selectedDocType, setSelectedDocType] = useState("document");
    const [banksList, setBanksList] = useState([]);
    const [selectedBankId, setSelectedBankId] = useState('');
    const [filteredBranches, setFilteredBranches] = useState([]);
    const [userId, setUserId] = useState(null);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [previewDocument, setPreviewDocument] = useState(null);
    const fileInputRef = useRef(null);
    const categoryDropdownRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [formErrors, setFormErrors] = useState({});
    const [attemptedSubmit, setAttemptedSubmit] = useState(false);

    const fileTypes = {
        document: ".pdf,.doc,.docx,.txt",
        image: ".jpg,.jpeg,.png,.gif,.webp",
        video: ".mp4,.mov,.avi,.webm",
        audio: ".mp3,.wav,.ogg,.m4a",
        presentation: ".ppt,.pptx",
        spreadsheet: ".xls,.xlsx,.csv",
        archive: ".zip,.rar,.7z,.tar,.gz"
    };

    // Close dropdown when clicking outside
    useEffect(() => {

        function handleClickOutside(event) {
            if (categoryDropdownRef.current && !categoryDropdownRef.current.contains(event.target)) {
                setShowCategoryDropdown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleBackClick = () => {
        if (breadcrumbs.length > 0) {
            const newBreadcrumbs = [...breadcrumbs];
            newBreadcrumbs.pop();
            setBreadcrumbs(newBreadcrumbs);

            if (newBreadcrumbs.length === 0) {
                setCurrentFolder(null);
            } else {
                const parentFolder = documents.find(doc => doc.id === newBreadcrumbs[newBreadcrumbs.length - 1].id);
                setCurrentFolder(parentFolder);
            }
        }
    };

    //To handle document preview
    const handleDocumentClick = (doc) => {
        if (doc.type !== "folder") {
            setPreviewDocument({
                ...doc,  // Spread the entire doc object to preserve all properties
                previewUrl: doc.url || getStaticDocumentPath(doc.type)
            });
            setShowPreviewModal(true);
        } else {
            handleFolderClick(doc);
        }
    };

    //To handle folder preview
    const handleFolderClick = (folder) => {
        setCurrentFolder(folder);
        setBreadcrumbs([...breadcrumbs, { id: folder.id, name: folder.name }]);
    };

    //filtering documents based on search and category selection
    const filteredDocuments = documents.filter(doc => {
        // Search filter
        const matchesSearch = doc.name.toLowerCase().includes(searchQuery.toLowerCase());

        // Folder filter - use either the prop folderId or currentFolder.id
        let matchesFolder = true;
        if (folderId) {
            matchesFolder = doc.parentId === folderId;
        } else if (currentFolder) {
            matchesFolder = doc.parentId === currentFolder.id;
        } else {
            matchesFolder = !doc.parentId; // Only show root documents when no folder is selected
        }

        // Type filter
        let matchesType = true;
        if (selectedType !== "All") {
            if (selectedType === "Document") {
                matchesType = ["pdf", "word", "text", "powerpoint", "excel"].includes(doc.type);
            } else if (selectedType === "Audio") {
                matchesType = doc.type === "audio";
            } else if (selectedType === "Video") {
                matchesType = doc.type === "video";
            } else if (selectedType === "Image") {
                matchesType = doc.type === "image";
            } else if (selectedType === "Folder") {
                matchesType = doc.type === "folder";
            }
        }

        return matchesSearch && matchesType && matchesFolder;
    });

    //Method to upload doc in specific folder 
    const handleUploadClick = () => {
        resetUploadForm();
        setShowUploadModal(true);
    };

    //After uploading doc
    const resetUploadForm = () => {
        setDocumentName("");
        setSelectedRegion("");
        setSelectedBank("");
        setSelectedBankId('');
        setSelectedBranch("");
        setSizeError("");
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };

    const toggleCategoryDropdown = () => {
        setShowCategoryDropdown(!showCategoryDropdown);
    };

    const handleTypeSelect = (type) => {
        setSelectedType(type);
        setShowCategoryDropdown(false);
    };

    useEffect(() => {
        if (documentName.trim()) setFormErrors(prev => ({ ...prev, documentName: undefined }));
    }, [documentName]);

    useEffect(() => {
        if (selectedDocType) setFormErrors(prev => ({ ...prev, docType: undefined }));
    }, [selectedDocType]);

    useEffect(() => {
        if (selectedBankId) setFormErrors(prev => ({ ...prev, bank: undefined }));
    }, [selectedBankId]);

    useEffect(() => {
        if (selectedBranch) setFormErrors(prev => ({ ...prev, branch: undefined }));
    }, [selectedBranch]);

    useEffect(() => {
        if (selectedFile) setFormErrors(prev => ({ ...prev, file: undefined }));
    }, [selectedFile]);

    const closeUploadModal = () => {
        setShowUploadModal(false);
        resetUploadForm();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 5 * 1024 * 1024) { // 5MB limit
                setSizeError('File size exceeds 5MB limit');
                setSelectedFile(null);
                e.target.value = null; // Reset the input
            } else {
                setSizeError('');
                setSelectedFile(file);
            }
        }
    };

    //To handle folder, docs view in UI
    const renderBreadcrumbs = () => {
        if (breadcrumbs.length === 0) return null;

        return (
            <div style={{
                display: "flex",
                alignItems: "center",
                padding: "10px 16px",
                //backgroundColor: "#fff",
                borderRadius: "8px",
                marginBottom: "5px",
                marginLeft: "-10px"
            }}>
                <button
                    onClick={handleBackClick}
                    style={{
                        background: "none",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        marginRight: "10px",
                        color: "#2596be"
                    }}
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    {/* <span style={{ marginLeft: "5px" }}>Back</span> */}
                </button>

                <div style={{ display: "flex", alignItems: "center" }}>
                    {breadcrumbs.map((crumb, index) => (
                        <div key={crumb.id} style={{ display: "flex", alignItems: "center" }}>
                            {index > 0 && (
                                <span style={{ margin: "0 8px", color: "#aaa" }}>/</span>
                            )}
                            <span style={{ marginTop: '5px', color: "#2596be" }}>{crumb.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    //To upload document in a specif folder
    const handleSubmitUpload = (e) => {
        e.preventDefault();
        if (!documentName || !selectedBank || !selectedBranch) {
            alert("Please fill all required fields");
            return;
        }
        const file = fileInputRef.current.files[0];
        if (!file) {
            alert("Please select a file to upload");
            return;
        }
        // Check file size (5MB = 5 * 1024 * 1024 bytes)
        if (file.size > 5 * 1024 * 1024) {
            setSizeError("File size exceeds 5MB limit");
            return;
        }

        e.preventDefault();
        setAttemptedSubmit(true);

        if (validateForm()) {
            // Add new document
            const newDoc = {
                id: documents.length + 1000, // Ensure unique ID
                name: documentName,
                type: getFileType(file.name),
                uploadedBy: userId,
                size: formatFileSize(file.size),
                region: selectedRegion,
                bank: selectedBank,
                branch: selectedBranch,
                parentId: currentFolder ? currentFolder.id : undefined // Add parentId if in a folder
            };

            setDocuments([...documents, newDoc]);
            setShowUploadModal(false);
            resetUploadForm();
            toast.success("Document Uploaded successfully!", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
            });
            // alert("Form submitted successfully!");
            // closeUploadModal();
        }


    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        if (files.length > 0) {
            const file = files[0];
            if (file.size > 5 * 1024 * 1024) {
                setSizeError('File size exceeds 5MB limit');
                setSelectedFile(null);
            } else {
                // Check if the file type matches the selected document type
                const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
                const acceptedTypes = fileTypes[selectedDocType]?.split(',') || [];
                const isValidType = acceptedTypes.some(type => type.includes(fileExtension));

                if (selectedDocType && !isValidType) {
                    setSizeError(`Invalid file type for ${selectedDocType}. Please select a ${acceptedTypes.join(', ')} file.`);
                    setSelectedFile(null);
                } else {
                    setSizeError('');
                    setSelectedFile(file);
                    if (fileInputRef.current) {
                        // Create a DataTransfer to set the file input's files
                        const dataTransfer = new DataTransfer();
                        dataTransfer.items.add(file);
                        fileInputRef.current.files = dataTransfer.files;
                    }
                }
            }
        }
    };

    //Validations while uploading docs
    const validateForm = () => {
        const errors = {};
        if (!documentName.trim()) errors.documentName = "Document title is required";
        if (!selectedDocType) errors.docType = "Document type is required";
        if (!selectedBankId) errors.bank = "Bank selection is required";
        if (!selectedBranch) errors.branch = "Branch selection is required";
        if (!selectedFile) errors.file = "File is required";

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    //To get file type 
    const getFileType = (filename) => {
        const extension = filename.split('.').pop().toLowerCase();

        const typeMap = {
            'pdf': 'pdf',
            'doc': 'word',
            'docx': 'word',
            'xls': 'excel',
            'xlsx': 'excel',
            'ppt': 'powerpoint',
            'pptx': 'powerpoint',
            'txt': 'text',
            'zip': 'archive',
            'rar': 'archive',
            'mp3': 'audio',
            'wav': 'audio',
            'mp4': 'video',
            'mov': 'video',
            'jpg': 'image',
            'jpeg': 'image',
            'png': 'image',
            'gif': 'image',
        };

        return typeMap[extension] || 'file';
    };

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return bytes + ' B';
        else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        else return (bytes / 1048576).toFixed(1) + ' MB';
    };

    //To add icon to that doc based on type
    const getFileIcon = (type) => {
        switch (type) {
            case 'folder':
                return (
                    <div className="w-10 h-10 flex items-center justify-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z" fill="#90CAF9" stroke="#42A5F5" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                );
            case 'pdf':
                return (
                    <div className="w-10 h-10 flex items-center justify-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#FFCDD2" stroke="#E57373" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 3V8H19M11.5 13.5H9.5M12 17H9.5M14.5 10H9.5" stroke="#E57373" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                );
            case 'excel':
                return (
                    <div className="w-10 h-10 flex items-center justify-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#C8E6C9" stroke="#81C784" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 3V8H19M9 13H15M9 17H15M9 9H10" stroke="#81C784" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                );
            case 'text':
                return (
                    <div className="w-10 h-10 flex items-center justify-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#E1F5FE" stroke="#4FC3F7" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 3V8H19M9 13H15M9 17H15M9 9H10" stroke="#4FC3F7" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                );
            case 'powerpoint':
                return (
                    <div className="w-10 h-10 flex items-center justify-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#FFECB3" stroke="#FFD54F" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 3V8H19M9 13H15M9 17H15M9 9H10" stroke="#FFD54F" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                );
            case 'word':
                return (
                    <div className="w-10 h-10 flex items-center justify-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#BBDEFB" stroke="#64B5F6" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 3V8H19M9 13H15M9 17H15M9 9H10" stroke="#64B5F6" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                );
            case 'archive':
                return (
                    <div className="w-10 h-10 flex items-center justify-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#D7CCC8" stroke="#A1887F" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 3V8H19M10 12H14M10 16H14" stroke="#A1887F" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                );
            case 'audio':
                return (
                    <div className="w-10 h-10 flex items-center justify-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#E1BEE7" stroke="#BA68C8" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 3V8H19" stroke="#BA68C8" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 11V17M10 13V15M14 13V15" stroke="#BA68C8" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                );
            case 'video':
                return (
                    <div className="w-10 h-10 flex items-center justify-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#FFCCBC" stroke="#FF8A65" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 3V8H19" stroke="#FF8A65" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M10 13L15 13.5V16.5L10 17V13Z" stroke="#FF8A65" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                );
            case 'image':
                return (
                    <div className="w-10 h-10 flex items-center justify-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#C8E6C9" stroke="#81C784" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 3V8H19" stroke="#81C784" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                            <circle cx="10.5" cy="11.5" r="1.5" fill="#81C784" />
                            <path d="M7 18L10 15L12 17L15 14L17 16" stroke="#81C784" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                );
            default:
                return (
                    <div className="w-10 h-10 flex items-center justify-center">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#F5F5F5" stroke="#9E9E9E" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 3V8H19M9 13H15M9 17H15M9 9H10" stroke="#9E9E9E" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                );
        }
    };

    useEffect(() => {
        getUserProfile();
        fetchUserProfile();
    }, []);

    const getUserProfile = async () => {
        try {
            const userProfile = await getData(getThemeURL);
            if (userProfile && userProfile.length > 0) {
                fetchBanks(userProfile[0]);
            }
        } catch (error) {
            console.error("Error fetching user profile:", error);
            toast.error("Failed to fetch user profile", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
            });
        }
    };

    const createPayload = (profile) => {
        let admin_role = "U"; // default value

        if (profile.role_name === "HO") {
            admin_role = "HO";
        } else if (profile.role_name === "SUPER ADMIN") {
            admin_role = "SA";
        }

        return {
            admin_role: admin_role,
            bank_id: profile.bank_id || null,
            branch_id: profile.branch_id || null
        };
    };

    const fetchBanks = async (profile) => {
        try {
            const payload = createPayload(profile);
            const response = await postDataWithBody(getallBanksByRole, payload, {});
            if (response && Array.isArray(response)) {
                setBanksList(response);
            } else {
                console.error("Invalid banks data format:", response);
                toast.error("Failed to load banks data");
            }
        } catch (error) {
            console.error("Error fetching banks:", error);
            toast.error("Failed to load banks data");
        }
    };

    const fetchBranches = async (bankId) => {
        try {
            const response = await getData(getbarches.replace("ID", bankId));
            if (response && Array.isArray(response)) {
                setFilteredBranches(response);
            } else {
                console.error(`Invalid branches data format for bank ${bankId}:`, response);
                setFilteredBranches([]);
            }
        } catch (error) {
            console.error(`Error fetching branches for bank ${bankId}:`, error);
            setFilteredBranches([]);
        }
    };

    const handleBankChange = (e) => {
        const bankId = e.target.value;
        setSelectedBankId(bankId);
        setSelectedBank(bankId);
        setSelectedBranch(''); // Reset branch selection

        if (bankId) {
            fetchBranches(bankId);
        } else {
            setFilteredBranches([]);
        }
    };

    const fetchUserProfile = async () => {
        try {
            const response = await getData(getThemeURL);
            if (response && Array.isArray(response) && response.length > 0) {
                setUserId(response[0].user_name); // Get `id` from the first user
            }
        } catch (error) {
            console.error("Error fetching user profile:", error);
        }
    };

    return (
        <div className="main-container bg-white p-0">
            {/* Header Tabs - On white background */}
            <div className="header-tabs" style={{
                display: "flex",
                marginBottom: "5px",
                marginLeft: '-12px',
                marginRight: '-12px',
                backgroundColor: "white",
                padding: "8px 16px",
                marginTop: '-16px',
                borderRadius: "8px"
            }}>

                <div style={{ marginLeft: "auto" }}>
                    <button
                        onClick={handleUploadClick}
                        style={{
                            backgroundColor: "#2596be",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            padding: "10px 15px",

                            marginTop: '5px',
                            cursor: "pointer",
                            fontWeight: "500"
                        }}
                    >
                        Upload a Document
                    </button>
                </div>
            </div>
            {/* Content area with gray background and rounded corners */}
            <div className="content-container" style={{
                backgroundColor: "#F9F9F9",
                borderRadius: "12px",
                padding: "10px"
            }}>
                {renderBreadcrumbs()}
                {/* Filter Tabs and Search */}
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "15px",
                    marginLeft: "-10px",
                    padding: "12px 16px",
                    gap: "10px"
                }}>
                    {/* Search Bar */}
                    <div style={{
                        width: windowWidth < 768 ? '200px' : '200px', // Reduced width values
                        position: "relative"
                    }}>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                            padding: "0 10px",
                            backgroundColor: "white",
                            width: "100%", // Ensure the inner div takes full width of container
                            boxSizing: "border-box" // Include padding in width calculation
                        }}>
                            <input
                                type="text"
                                placeholder="Search"
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{
                                    flex: 1,
                                    border: "none",
                                    outline: "none",
                                    padding: "3px 4px",
                                    fontSize: "14px",
                                    minWidth: "0" // Allow the input to shrink
                                }}
                            />
                            <Search size={18} color="#666" />
                        </div>
                    </div>

                    {/* Type Categories Dropdown - FIXED */}
                    <div style={{ position: "relative" }} ref={categoryDropdownRef}>
                        <button
                            onClick={toggleCategoryDropdown}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "3px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: "white",
                                cursor: "pointer",
                                fontSize: "14px",
                                color: "grey",
                            }}
                        >
                            {selectedType === "All" ? "All Categories" : selectedType} <span style={{ marginLeft: "5px", color: "grey", }}>▼</span>
                        </button>
                        {showCategoryDropdown && (
                            <div
                                style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: 0,
                                    width: "150px",
                                    backgroundColor: "white",
                                    border: "1px solid #ddd",
                                    borderRadius: "5px",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                    zIndex: 10
                                }}
                            >
                                {typeCategories.map((type) => (
                                    <div
                                        key={type}
                                        onClick={() => handleTypeSelect(type)}
                                        style={{
                                            padding: "8px 12px",
                                            cursor: "pointer",
                                            backgroundColor: selectedType === type ? "#f0f0f0" : "transparent"
                                        }}
                                    >
                                        {type}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Document Grid - Matching the 3 items per row layout */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                        gap: "20px",
                        marginTop: "-10px"
                    }}
                >
                    {filteredDocuments.map((doc) => (
                        <div
                            key={doc.id}
                            style={{
                                borderRadius: "12px",
                                overflow: "hidden",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                                backgroundColor: "#fff",
                                position: "relative",
                                cursor: "pointer",
                                transition: "transform 0.2s, box-shadow 0.2s",
                                height: "100px",
                            }}
                            onClick={() => doc.type === "folder" ? handleFolderClick(doc) : handleDocumentClick(doc)}
                            onMouseOver={(e) => {
                                e.currentTarget.style.transform = "translateY(-2px)";
                                e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.1)";
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.05)";
                            }}
                        >
                            {/* Header */}
                            <div style={{ display: "flex", padding: "16px", alignItems: "center" }}>
                                <div
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                        backgroundColor: "#2596be",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginRight: "14px",
                                        marginTop: "10px",
                                    }}
                                >
                                    {getFileIcon(doc.type)}
                                </div>

                                <div style={{ flex: 1 }}>
                                    <div style={{ fontWeight: 400, fontSize: "12px", color: "#333", marginTop: "15px", }}>
                                        {doc.name}
                                    </div>
                                    <div style={{ fontSize: "12px", color: "#aaa", marginTop: "4px" }}>
                                        {doc.type === 'folder' ? `${doc.files} files` : `Uploaded by: ${doc.uploadedBy}`}
                                    </div>
                                </div>

                                <div
                                    style={{
                                        fontSize: "12px",
                                        backgroundColor: "#e6f7ef",
                                        borderRadius: "12px",
                                        padding: "4px 10px",
                                        fontWeight: 500,
                                        color: "#00BF28"
                                    }}
                                >
                                    {doc.size}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {/* Updated Upload Modal with new fields */}
            {showUploadModal && (
                <div
                    className="fixed inset-0 flex items-center justify-center z-50"
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000
                    }}
                    onClick={(e) => {
                        if (e.target === e.currentTarget) closeUploadModal();
                    }}
                >
                    <div
                        className="bg-white rounded-lg p-6 max-w-md max-h-[90vh] overflow-y-auto"
                        style={{
                            backgroundColor: "white",
                            borderRadius: "16px",
                            padding: "20px",
                            width: "90%",
                            maxWidth: "480px",
                            maxHeight: "90vh",
                            overflowY: "auto",
                            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.15)",
                            animation: "fadeIn 0.3s ease-out",
                            border: "1px solid #e0e0e0"
                        }}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "16px",
                            borderBottom: "1px solid #f0f0f0",
                            paddingBottom: "12px"
                        }}>
                            <h2 style={{ fontWeight: "600", fontSize: "18px", color: "#2596be" }}>Upload Document</h2>
                            <button
                                onClick={closeUploadModal}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    color: "#888",
                                    transition: "color 0.2s",
                                    width: "28px",
                                    height: "28px",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                                onMouseOver={(e) => e.currentTarget.style.color = "#333"}
                                onMouseOut={(e) => e.currentTarget.style.color = "#888"}
                            >
                                &times;
                            </button>
                        </div>

                        <form onSubmit={handleSubmitUpload}>
                            {/* Document Name Field */}
                            <div style={{ marginBottom: "16px" }}>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: "6px",
                                        fontSize: "13px",
                                        fontWeight: "500",
                                        color: "#444"
                                    }}
                                >
                                    Document Title*
                                </label>
                                <input
                                    type="text"
                                    value={documentName}
                                    onChange={(e) => setDocumentName(e.target.value)}
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        borderRadius: "6px",
                                        border: "1px solid #e0e0e0",
                                        fontSize: "14px",
                                        transition: "border 0.2s",
                                        outline: "none"
                                    }}
                                    onFocus={(e) => e.target.style.border = "1px solid #2596be"}
                                    onBlur={(e) => e.target.style.border = "1px solid #e0e0e0"}
                                    required
                                />
                            </div>

                            {/* Document Type Selection - Redesigned as smaller tiles */}
                            <div style={{ marginBottom: "16px" }}>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: "6px",
                                        fontSize: "13px",
                                        fontWeight: "500",
                                        color: "#444"
                                    }}
                                >
                                    Document Type*
                                </label>

                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "8px"
                                }}>
                                    {["document", "image", "video", "audio", "presentation", "spreadsheet", "archive"].map(type => (
                                        <div
                                            key={type}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                padding: "8px 4px",
                                                border: selectedDocType === type ? "2px solid #2596be" : "1px solid #e0e0e0",
                                                borderRadius: "6px",
                                                cursor: "pointer",
                                                backgroundColor: selectedDocType === type ? "rgba(37, 150, 190, 0.05)" : "white",
                                                transition: "all 0.2s"
                                            }}
                                            onClick={() => setSelectedDocType(type)}
                                        >
                                            {/* Document Type Icons - Smaller size */}
                                            <div style={{ marginBottom: "4px" }}>
                                                {type === "document" && (
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#BBDEFB" stroke="#64B5F6" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M14 3V8H19M9 13H15M9 17H15M9 9H10" stroke="#64B5F6" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                )}
                                                {type === "image" && (
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#C8E6C9" stroke="#81C784" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M14 3V8H19" stroke="#81C784" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                        <circle cx="10.5" cy="11.5" r="1.5" fill="#81C784" />
                                                        <path d="M7 18L10 15L12 17L15 14L17 16" stroke="#81C784" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                )}
                                                {type === "video" && (
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#FFCCBC" stroke="#FF8A65" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M14 3V8H19" stroke="#FF8A65" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M10 13L15 13.5V16.5L10 17V13Z" stroke="#FF8A65" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                )}
                                                {type === "audio" && (
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#E1BEE7" stroke="#BA68C8" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M14 3V8H19" stroke="#BA68C8" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M12 11V17M10 13V15M14 13V15" stroke="#BA68C8" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                )}
                                                {type === "presentation" && (
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#FFECB3" stroke="#FFD54F" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M14 3V8H19M9 13H15M9 17H15M9 9H10" stroke="#FFD54F" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                )}
                                                {type === "spreadsheet" && (
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#C8E6C9" stroke="#81C784" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M14 3V8H19M9 13H15M9 17H15M9 9H10" stroke="#81C784" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                )}
                                                {type === "archive" && (
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V8L14 3Z" fill="#D7CCC8" stroke="#A1887F" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M14 3V8H19M10 12H14M10 16H14" stroke="#A1887F" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                )}
                                            </div>
                                            <div style={{
                                                fontSize: "10px",
                                                textTransform: "capitalize",
                                                color: selectedDocType === type ? "#2596be" : "#666",
                                                fontWeight: selectedDocType === type ? "500" : "normal"
                                            }}>
                                                {type}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Bank Dropdown */}
                            <div style={{ marginBottom: "16px" }}>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: "6px",
                                        fontSize: "13px",
                                        fontWeight: "500",
                                        color: "#444"
                                    }}
                                >
                                    Bank*
                                </label>
                                <select
                                    value={selectedBankId}
                                    onChange={handleBankChange}
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        borderRadius: "6px",
                                        border: "1px solid #e0e0e0",
                                        fontSize: "14px",
                                        backgroundColor: "white",
                                        appearance: "none",
                                        backgroundImage: "url('data:image/svg+xml;utf8,<svg fill=\"%23888\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>')",
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "right 10px center",
                                        backgroundSize: "16px",
                                        transition: "border 0.2s",
                                        outline: "none"
                                    }}
                                    onFocus={(e) => e.target.style.border = "1px solid #2596be"}
                                    onBlur={(e) => e.target.style.border = "1px solid #e0e0e0"}
                                    required
                                >
                                    <option value="">Select Bank</option>
                                    {banksList.map(bank => (
                                        <option key={bank.id} value={bank.id}>{bank.bankName}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Branch Dropdown - Updated */}
                            <div style={{ marginBottom: "16px" }}>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: "6px",
                                        fontSize: "13px",
                                        fontWeight: "500",
                                        color: "#444"
                                    }}
                                >
                                    Branch*
                                </label>
                                <select
                                    value={selectedBranch}
                                    onChange={(e) => setSelectedBranch(e.target.value)}
                                    disabled={!selectedBankId}
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        borderRadius: "6px",
                                        border: "1px solid #e0e0e0",
                                        fontSize: "14px",
                                        backgroundColor: selectedBankId ? "white" : "#f9f9f9",
                                        appearance: "none",
                                        backgroundImage: "url('data:image/svg+xml;utf8,<svg fill=\"%23888\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>')",
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "right 10px center",
                                        backgroundSize: "16px",
                                        transition: "border 0.2s",
                                        outline: "none",
                                        cursor: selectedBankId ? "pointer" : "not-allowed"
                                    }}
                                    onFocus={(e) => e.target.style.border = "1px solid #2596be"}
                                    onBlur={(e) => e.target.style.border = "1px solid #e0e0e0"}
                                    required
                                >
                                    <option value="">Select Branch</option>
                                    {filteredBranches.map(branch => (
                                        <option key={branch.id} value={branch.id}>{branch.branchName}</option>
                                    ))}
                                </select>
                                {!selectedBankId && (
                                    <p style={{ fontSize: "12px", color: "#888", marginTop: "4px" }}>
                                        Please select a bank first
                                    </p>
                                )}
                            </div>


                            {/* File Upload */}
                            <div style={{ marginBottom: "16px" }}>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: "6px",
                                        fontSize: "13px",
                                        fontWeight: "500",
                                        color: "#444"
                                    }}
                                >
                                    Select File* (Max 5MB)
                                </label>
                                <div
                                    style={{
                                        border: "2px dashed #e0e0e0",
                                        borderRadius: "6px",
                                        padding: "12px",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        backgroundColor: "#f9f9f9",
                                        transition: "all 0.2s",
                                        position: "relative"  // Added for positioning the close button
                                    }}
                                    onClick={() => fileInputRef.current.click()}
                                    onDragOver={(e) => {
                                        e.preventDefault();
                                        e.currentTarget.style.borderColor = "#2596be";
                                        e.currentTarget.style.backgroundColor = "rgba(37, 150, 190, 0.05)";
                                    }}
                                    onDragLeave={(e) => {
                                        e.currentTarget.style.borderColor = "#e0e0e0";
                                        e.currentTarget.style.backgroundColor = "#f9f9f9";
                                    }}
                                    onDrop={(e) => {
                                        handleDrop(e);
                                        e.currentTarget.style.borderColor = "#e0e0e0";
                                        e.currentTarget.style.backgroundColor = "#f9f9f9";
                                    }}
                                >
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ margin: "0 auto 8px" }}>
                                        <path d="M12 15V3M12 3L7 8M12 3L17 8" stroke="#2596be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M20 16.8V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V16.8" stroke="#2596be" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <p style={{ margin: "0", color: "#666", fontSize: "13px" }}>Drag & drop file or click to browse</p>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        onChange={handleFileChange}
                                        accept={fileTypes[selectedDocType]}
                                        style={{ display: "none" }}
                                        required
                                    />
                                    {fileInputRef.current?.files?.[0] && (
                                        <div style={{
                                            position: "relative",
                                            marginTop: "8px",
                                            padding: "8px",
                                            backgroundColor: "rgba(37, 150, 190, 0.1)",
                                            borderRadius: "4px"
                                        }}>
                                            <p style={{
                                                fontSize: "12px",
                                                color: "#2596be",
                                                margin: 0,
                                                paddingRight: "20px", // Space for the close button
                                                textAlign: "left",
                                                wordBreak: "break-word"
                                            }}>
                                                {fileInputRef.current.files[0].name}
                                            </p>
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    fileInputRef.current.value = '';
                                                    setSizeError(null);
                                                    setAttemptedSubmit(false); // Also reset submit attempt
                                                }}
                                                style={{
                                                    position: "absolute",
                                                    top: "7px",
                                                    right: "4px",
                                                    width: "20px",
                                                    height: "20px",
                                                    borderRadius: "50%",
                                                    background: "#f5f5f5",
                                                    border: "1px solid #e0e0e0",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    cursor: "pointer",
                                                    color: "#888",
                                                    fontSize: "12px",
                                                    padding: 0,
                                                    transition: "all 0.2s"
                                                }}
                                                onMouseOver={(e) => {
                                                    e.currentTarget.style.background = "#e53935";
                                                    e.currentTarget.style.color = "white";
                                                    e.currentTarget.style.borderColor = "#e53935";
                                                }}
                                                onMouseOut={(e) => {
                                                    e.currentTarget.style.background = "#f5f5f5";
                                                    e.currentTarget.style.color = "#888";
                                                    e.currentTarget.style.borderColor = "#e0e0e0";
                                                }}
                                            >
                                                &times;
                                            </button>
                                        </div>
                                    )}
                                </div>
                                {sizeError && (
                                    <p style={{ color: "#e53935", fontSize: "12px", marginTop: "4px", display: "flex", alignItems: "center" }}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "4px" }}>
                                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#e53935" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M12 8V12" stroke="#e53935" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <circle cx="12" cy="16" r="0.5" stroke="#e53935" strokeWidth="2" />
                                        </svg>
                                        {sizeError}
                                    </p>
                                )}
                                {attemptedSubmit && !fileInputRef.current?.files?.[0] && (
                                    <p style={{ color: "#e53935", fontSize: "12px", marginTop: "4px", display: "flex", alignItems: "center" }}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "4px" }}>
                                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#e53935" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M12 8V12" stroke="#e53935" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <circle cx="12" cy="16" r="0.5" stroke="#e53935" strokeWidth="2" />
                                        </svg>
                                        Please select a file to upload
                                    </p>
                                )}
                            </div>

                            {/* Submit Button */}
                            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
                                <button
                                    type="button"
                                    onClick={closeUploadModal}
                                    style={{
                                        padding: "8px 12px",
                                        marginRight: "8px",
                                        backgroundColor: "#f5f5f5",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        fontWeight: "500",
                                        transition: "background 0.2s",
                                        fontSize: "13px"
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#e0e0e0"}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    style={{
                                        padding: "8px 16px",
                                        backgroundColor: "#2596be",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        fontWeight: "500",
                                        transition: "background 0.2s",
                                        boxShadow: "0 2px 5px rgba(37, 150, 190, 0.3)",
                                        fontSize: "13px"
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#1d7a9a"}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#2596be"}
                                >
                                    Upload
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            {/* preview document modal */}
            {showPreviewModal && previewDocument && (
                <div
                    className="fixed inset-0 flex items-center justify-center z-50"
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                        zIndex: 1000
                    }}
                    onClick={(e) => {
                        if (e.target === e.currentTarget) setShowPreviewModal(false);
                    }}
                >
                    <div
                        className="bg-white rounded-lg max-w-4xl max-h-[90vh] overflow-hidden flex flex-col"
                        style={{
                            backgroundColor: "white",
                            borderRadius: "16px",
                            width: "90%",
                            maxWidth: "900px",
                            maxHeight: "90vh",
                            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.15)",
                            animation: "fadeIn 0.3s ease-out",
                            border: "1px solid #e0e0e0",
                            display: "flex",
                            marginLeft: '60px',
                            flexDirection: "column"
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Header */}
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "16px 20px",
                            borderBottom: "1px solid #f0f0f0"
                        }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                        backgroundColor: "#2596be",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginRight: "14px"
                                    }}
                                >
                                    {getFileIcon(previewDocument.type)}
                                </div>
                                <div>
                                    <h2 style={{ fontWeight: "600", fontSize: "18px", color: "#333", marginBottom: "4px" }}>
                                        {previewDocument.name}
                                    </h2>
                                    <div style={{ display: "flex", alignItems: "center", fontSize: "12px", color: "#888" }}>
                                        <span style={{ marginRight: "16px" }}>
                                            {previewDocument.type} • {previewDocument.size}
                                        </span>
                                        <span>Uploaded by: {previewDocument.uploadedBy}</span>
                                    </div>
                                </div>
                            </div>

                            <div style={{ display: "flex", alignItems: "center" }}>
                                {/* <button
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              marginRight: "12px",
              display: "flex",
              alignItems: "center",
              color: "#2596be",
              fontSize: "13px"
            }}
          >
            <Download size={16} style={{ marginRight: "4px" }} />
            Download
          </button> */}
                                <button
                                    onClick={() => setShowPreviewModal(false)}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        fontSize: "20px",
                                        cursor: "pointer",
                                        color: "#888",
                                        width: "28px",
                                        height: "28px",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    &times;
                                </button>
                            </div>
                        </div>

                        {/* Document Preview Area */}
                        <div style={{
                            flex: 1,
                            overflowY: "auto",
                            display: "flex",
                            flexDirection: "column",
                            padding: "0"
                        }}>
                            {/* Preview content based on document type */}
                            {previewDocument.type === "image" ? (
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "20px",
                                    height: "100%",
                                    backgroundColor: "#f9f9f9"
                                }}>
                                    <img
                                        src={previewDocument.url || getStaticDocumentPath('image') || `/api/placeholder/800/600`}
                                        alt={previewDocument.name}
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: "70vh",
                                            boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                                        }}
                                    />
                                </div>
                            ) : previewDocument.type === "pdf" ? (
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    padding: "20px",
                                    backgroundColor: "#f9f9f9",
                                    height: "100%"
                                }}>
                                    <iframe
                                        src={previewDocument.url || getStaticDocumentPath('pdf')}
                                        style={{
                                            width: "100%",
                                            height: "70vh",
                                            border: "none",
                                            borderRadius: "4px",
                                            boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                                        }}
                                        title={previewDocument.name}
                                    />
                                </div>
                            ) : previewDocument.type === "excel" ? (
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    padding: "20px",
                                    backgroundColor: "#f9f9f9",
                                    height: "100%"
                                }}>
                                    <iframe
                                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(previewDocument.url)}`}
                                        style={{
                                            width: "100%",
                                            height: "70vh",
                                            border: "none",
                                            borderRadius: "4px",
                                            boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                                        }}
                                        title={previewDocument.name}
                                    />
                                </div>
                            ) : previewDocument.type === "word" ? (
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    padding: "20px",
                                    backgroundColor: "#f9f9f9",
                                    height: "100%"
                                }}>
                                    <iframe
                                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(previewDocument.url)}`}
                                        style={{
                                            width: "100%",
                                            height: "70vh",
                                            border: "none",
                                            borderRadius: "4px",
                                            boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                                        }}
                                        title={previewDocument.name}
                                    />
                                </div>
                            ) : previewDocument.type === "powerpoint" ? (
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    padding: "20px",
                                    backgroundColor: "#f9f9f9",
                                    height: "100%"
                                }}>
                                    <iframe
                                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(previewDocument.url)}`}
                                        style={{
                                            width: "100%",
                                            height: "70vh",
                                            border: "none",
                                            borderRadius: "4px",
                                            boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                                        }}
                                        title={previewDocument.name}
                                    />
                                </div>
                            ) : previewDocument.type === "video" ? (
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "20px",
                                    height: "100%",
                                    backgroundColor: "#f9f9f9"
                                }}>
                                    <video
                                        controls
                                        style={{
                                            width: "100%",
                                            maxWidth: "800px",
                                            borderRadius: "4px",
                                            boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                                        }}
                                    >
                                        <source src={previewDocument.url || getStaticDocumentPath('video')} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            ) : previewDocument.type === "audio" ? (
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "20px",
                                    height: "100%",
                                    backgroundColor: "#f9f9f9"
                                }}>
                                    <div style={{
                                        width: "100%",
                                        maxWidth: "600px",
                                        backgroundColor: "#fff",
                                        borderRadius: "8px",
                                        padding: "20px",
                                        boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                                    }}>
                                        <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
                                            <div style={{
                                                width: "60px",
                                                height: "60px",
                                                borderRadius: "8px",
                                                backgroundColor: "#2596be",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                marginRight: "15px"
                                            }}>
                                                <FileMusic size={30} color="#fff" />
                                            </div>
                                            <div>
                                                <div style={{ fontSize: "16px", fontWeight: "500" }}>{previewDocument.name}</div>
                                                <div style={{ fontSize: "12px", color: "#888" }}>Audio File • {previewDocument.size}</div>
                                            </div>
                                        </div>

                                        <audio
                                            controls
                                            style={{ width: "100%", marginBottom: "15px" }}
                                        >
                                            <source src={previewDocument.url || getStaticDocumentPath('audio')} type="audio/mp3" />
                                            Your browser does not support the audio element.
                                        </audio>
                                    </div>
                                </div>
                            ) : previewDocument.type === "text" ? (
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    padding: "20px",
                                    backgroundColor: "#f9f9f9",
                                    height: "100%"
                                }}>
                                    <iframe
                                        src={previewDocument.url || getStaticDocumentPath('text')}
                                        style={{
                                            width: "100%",
                                            height: "70vh",
                                            border: "none",
                                            borderRadius: "4px",
                                            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                                            backgroundColor: "white"
                                        }}
                                        title={previewDocument.name}
                                    />
                                </div>
                            ) : (
                                <div style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "20px",
                                    height: "100%",
                                    backgroundColor: "#f9f9f9"
                                }}>
                                    <div style={{
                                        backgroundColor: "#fff",
                                        padding: "30px",
                                        borderRadius: "8px",
                                        textAlign: "center",
                                        boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
                                    }}>
                                        <FileIcon size={60} color="#2596be" style={{ marginBottom: "15px" }} />
                                        <h3 style={{ marginBottom: "10px" }}>Format not supported for preview</h3>
                                        <p style={{ color: "#666", marginBottom: "20px" }}>
                                            Please download the file to view its contents.
                                        </p>
                                        <button style={{
                                            padding: "8px 20px",
                                            backgroundColor: "#2596be",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "6px",
                                            cursor: "pointer",
                                            fontWeight: "500",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            margin: "0 auto"
                                        }}>
                                            <Download size={16} style={{ marginRight: "8px" }} />
                                            Download File
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Document Information Footer */}
                        <div style={{
                            borderTop: "1px solid #f0f0f0",
                            padding: "16px 20px",
                            backgroundColor: "#FAFAFA"
                        }}>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <div style={{ marginRight: "20px" }}>
                                        <div style={{ fontSize: "12px", color: "#666", marginBottom: "4px" }}>Bank</div>
                                        <div style={{ fontSize: "14px", fontWeight: "500" }}>{previewDocument.bank}</div>
                                    </div>
                                    <div>
                                        <div style={{ fontSize: "12px", color: "#666", marginBottom: "4px" }}>Branch</div>
                                        <div style={{ fontSize: "14px", fontWeight: "500" }}>{previewDocument.branch}</div>
                                    </div>
                                </div>
                                <div>
                                    <div style={{ fontSize: "12px", color: "#666", marginBottom: "4px" }}>Upload Date</div>
                                    <div style={{ fontSize: "14px", fontWeight: "500" }}>{previewDocument.date}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FoldersContent;